import $ from 'jquery';

$(document).ready(function () {
	$('#size-help').click(function (e) {
		e.preventDefault();
		$('#size-guide').addClass('visible');
	});

	$('#close-size-guide').click(function (e) {
		e.preventDefault();
		$('#size-guide').removeClass('visible');
	});

	$(document).click(function (event) {
		//if you click on anything except the modal itself or the "open modal" link, close the modal
		if (!$(event.target).closest('#size-guide,#size-help').length) {
			$('body').find('#size-guide').removeClass('visible');
		}
	});
});
